<div class="wrapper">
    <span>{{data.message}}</span>
    <button mat-raised-button (click)="reload();">
        <mat-icon>refresh</mat-icon>{{data.action}}
    </button>
</div>